<template>
    <div class="background">
        <img src='https://preprod.api.defipix.fr/logos/Defipix-logo.png' alt="logo defipix" class="logoDP">
        <h2 class="text">Il n'y a rien a voir ici :(</h2>
        <div class="button" @click="goHome()">
            <span>retourner sur défipix.fr</span>
        </div>
    </div>
</template>

<script>
export default {
    title: 'Défipix.fr | Mauvaise route !',
    methods: {
        goHome() {
            window.location = "http://www.defipix.fr";
        }
    },
}
</script>

<style scoped>
.background {
    background-color: #fff;
    width: 100wh;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.logoDP {
    height: 35%;
    max-width: unset;
    background-color: #fff;
}

.text {
    background-color: #fff;
    padding: 1em;
}

.button {
    background-color: #101588;
    color: #fff;
    font-weight: 600;
    padding: 1em;
    margin: 2em;
    border-radius: 15px;
}

.button:hover {
    cursor: pointer;
    color: #f677c4;
}
</style>


// WEBPACK FOOTER //
// src/router/NoRoute.vue